var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService, ScreenService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { fromEvent } from 'rxjs';
import { takeWhile, debounceTime, map, distinctUntilChanged, startWith, tap } from 'rxjs/operators';
import * as fromStore from '../../../store';
import * as tripFinderActions from '@ibe/store/actions/trip-finder.actions';
import { SearchParameters } from '@ibe/store/states/trip-finder.state';
import { TripFinderService } from '@ibe.services/mocks.tap/trip-finder.service';
var INDRASelectThemeModalComponent = /** @class */ (function (_super) {
    __extends(INDRASelectThemeModalComponent, _super);
    function INDRASelectThemeModalComponent(modalService, screen, tfService, store) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.screen = screen;
        _this.tfService = tfService;
        _this.store = store;
        _this.isAlive = true;
        _this.isLoading = true;
        _this.searchCriteria$ = _this.store.select(fromStore.getTripFinderSearchParameters);
        _this.searchCriteria = null;
        _this.currentSelectedThemesTotal = 0;
        _this.hasChanges = false;
        _this.selectedThemes = [];
        _this.themes = [
            {
                id: 'adventure',
                icon: 'destinations--adventure',
                label: 'Adventure'
            },
            {
                id: 'beach',
                icon: 'destinations--beach',
                label: 'Beach'
            },
            {
                id: 'culture',
                icon: 'destinations--culture',
                label: 'Culture'
            },
            {
                id: 'family',
                icon: 'destinations--family',
                label: 'Family'
            },
            {
                id: 'golf',
                icon: 'destinations--golf',
                label: 'Golf'
            },
            {
                id: 'nature',
                icon: 'destinations--nature',
                label: 'Nature'
            },
            {
                id: 'nightlife',
                icon: 'destinations--night_life',
                label: 'Nightlife'
            },
            {
                id: 'romance',
                icon: 'destinations--romance',
                label: 'Romance'
            },
            {
                id: 'shopping',
                icon: 'destinations--shopping',
                label: 'Shopping'
            },
            {
                id: 'snow',
                icon: 'destinations--snow',
                label: 'Snow'
            },
            {
                id: 'surf',
                icon: 'destinations--surf',
                label: 'Surf'
            },
            {
                id: 'gastronomy',
                icon: 'destinations--gastronomia',
                label: 'Gastronomy'
            },
            {
                id: 'relax',
                icon: 'destinations--relax',
                label: 'Relax'
            }
        ];
        _this.loading$ = _this.store.select(fromStore.getUserLoading);
        _this.isMobile$ = _this.store.select(fromStore.isScreenMobile);
        _this.isMobile = false;
        _this.isMobile$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.isMobile = value;
        });
        _this.resize$ = fromEvent(window, 'resize')
            .pipe(debounceTime(250), map(function () { return window.innerWidth; }), distinctUntilChanged(), startWith(window.innerWidth), tap(function (width) { return _this.screen.setWindowWidth(Number(width)); }));
        _this.searchCriteria$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (param) {
            if (param) {
                _this.searchCriteria = param;
                if (_this.searchCriteria.theme) {
                    _this.searchCriteria.theme.forEach(function (label) {
                        var themeObj = _this.themes.find(function (theme) { return theme.label === label; });
                        _this.selectedThemes.push(themeObj);
                    });
                }
                _this.currentSelectedThemesTotal = _this.selectedThemes.length;
            }
        });
        return _this;
    }
    INDRASelectThemeModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loading$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.isLoading = value;
        });
        this.resize$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe();
    };
    INDRASelectThemeModalComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRASelectThemeModalComponent.prototype.closeModal = function () {
        this.modalService.close();
    };
    INDRASelectThemeModalComponent.prototype.INDRA_handleSelectThemeClick = function (index) {
        var _this = this;
        var value = this.themes[index];
        if (this.selectedThemes.find(function (theme) { return theme.label === _this.themes[index].label; })) {
            this.selectedThemes.splice(this.selectedThemes.indexOf(value), 1);
        }
        else {
            this.selectedThemes.push(value);
        }
        if (this.currentSelectedThemesTotal === 0 && this.selectedThemes.length === 0) {
            this.hasChanges = false;
        }
        else {
            this.hasChanges = true;
        }
    };
    INDRASelectThemeModalComponent.prototype.INDRA_handleConfirmationClick = function () {
        var themesToStore = [];
        this.selectedThemes.forEach(function (theme) {
            themesToStore.push(theme.label);
        });
        // ADD to store
        var criteria = Object.assign(new SearchParameters(), this.searchCriteria, { theme: themesToStore.slice() });
        this.store.dispatch(new tripFinderActions.PutSearchParameters(criteria));
        this.modalService.close();
        this.tfService.getOffers(criteria);
    };
    INDRASelectThemeModalComponent.prototype.INDRA_isChecked = function (label) {
        return this.selectedThemes.find(function (theme) { return theme.label === label; }) !== undefined;
    };
    INDRASelectThemeModalComponent.prototype.INDRA_handleResetClick = function () {
        this.selectedThemes = [];
        this.hasChanges = this.currentSelectedThemesTotal !== 0;
    };
    return INDRASelectThemeModalComponent;
}(AbstractModalContentComponent));
export { INDRASelectThemeModalComponent };
